@if (dropdown) {
  <a [cdkMenuTriggerFor]="menu"
    (cdkMenuClosed)="showDropdown = false"
    (cdkMenuOpened)="showDropdown = true"
    class="dropdown-main"
    [ngClass]="dropdown.noUpperCase ? '' : 'uppercase'"
    >
    @if (dropdown.icon) {
      <span
        [appIcon]="dropdown.icon"
        class="icon"
      ></span>
    }
    {{ dropdown.dropdownButtonLabel ? (dropdown.dropdownButtonLabel | translate) : dropdown.dropdownButtonText }}
    <span appIcon="chevron-down"
      class="chevron"
      [class.inverted]="showDropdown"
    ></span>
  </a>
  <ng-template #menu>
    @if (dropdown.dropdownItems) {
      <div
        cdkMenu
        class="dropdown"
        >
        @for (item of dropdown.dropdownItems; track item) {
          @if (item.clickEvent) {
            <a
              cdkMenuItem
              (click)="item.clickEvent($event)"
              class="dropdown-item stretch"
              >
              {{ item.itemLabel ? (item.itemLabel | translate) : item.itemName }}
            </a>
          }
          @if (item.routerLink) {
            <a
              [routerLink]="item.routerLink | translateRoute"
              cdkMenuItem
              (click)="close()"
              class="dropdown-item stretch"
              >
              {{ item.itemLabel ? (item.itemLabel | translate) : item.itemName }}
            </a>
          }
          @if (localization.currentLocale$ | async; as locale) {
            @if (item.externalLink) {
              <a
                [href]="item.externalLink + (locale !== LocalesEnum.Nl ? LocalesEnum.En : LocalesEnum.Nl)"
                target="_blank"
                cdkMenuItem
                (click)="close()"
                class="dropdown-item stretch"
                >
                {{ item.itemLabel ? (item.itemLabel | translate) : item.itemName }}
              </a>
            }
          }
          <ng-container>
            @if (item.externalLinkNoLocale) {
              <a
                [href]="item.externalLinkNoLocale"
                target="_blank"
                cdkMenuItem
                (click)="close()"
                class="dropdown-item stretch"
                >
                {{ item.itemLabel ? (item.itemLabel | translate) : item.itemName }}
              </a>
            }
          </ng-container>
          @if (item.ppName ) {
            @if (item.ppName | positionedPageLink | async; as link) {
              <a
                [routerLink]="link"
                cdkMenuItem
                (click)="close()"
                class="dropdown-item stretch"
                >
                {{ item.itemLabel ? (item.itemLabel | translate) : item.itemName }}
              </a>
            }
          }
          @if (item.underLine) {
            <hr class="underline" />
          }
        }
        @if (userDropdown) {
          <hr class="underline" />
          <!-- Wrapping div is needed to prevent menu from closing when checking/unchecking
          ! TODO: Check if this can be refactored when new major version of Angular is available -->
          <div (click)="updateProfileService.hidePurchasePrice.setValue(! updateProfileService.hidePurchasePrice.value)"
            class="dropdown-item pointer"
            >
            <app-checkbox [control]="updateProfileService.hidePurchasePrice"
              [nativeMode]="true"
              [smallLabel]="true"
              class="no-pointer-events"
              >
              {{ 'my-data.hide-purchase-price' | translate }}
            </app-checkbox>
          </div>
        }
      </div>
    }
  </ng-template>
}
